import CardWrapper from '../../wrapper/card';
import { createFormConfigData } from '../../../helper/form_builder';
import CustomDropdown from '../../reusable/dropdown';
import LabelWrapper from '../../wrapper/label';
import { previewRenderFormThunk } from '../../../redux/thunks/form';
// import { useState } from 'react';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const PreviewFormComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { formFields, loaders, formTemplates, formHTML } = useSelector((state: RootState) => state.form);

    // const [, setFormData] = useState<Record<string, string | number | null | number[] | File | undefined>>({});

    // const handleFieldChange = (fieldId: string, value: string | number | null | number[] | File | undefined) => {
    //     setFormData((prev) => ({
    //         ...prev,
    //         [fieldId]: value
    //     }));
    // };

    const onChangeTemplate = async (e: string) => {
        try {
            const form_json = JSON.stringify(createFormConfigData(formFields));
            await dispatch(previewRenderFormThunk({
                form_json,
                form_title: formFields.formTitle,
                template_id: parseInt(e, 10)
            })).unwrap();
        } catch (err) {
            //
        }
    };

    return (<CardWrapper>
        <Box display="flex" minHeight="70vh">
            <Box display="flex" width="100%" minHeight="70vh" flexDirection="column" gap={2} mx="auto">
                {
                    loaders.isUpdating
                    ? <Box display="flex" flexDirection="column" gap={2} minHeight="70vh" justifyContent="center" alignItems="center">
                        <CircularProgress />
                        <Typography variant="subtitle1">Loading Preview...</Typography>
                    </Box>
                    : <iframe srcDoc={formHTML} height="100%" width="100%" style={{ border: 'none' }} />}
            </Box>
            <Box minHeight="70vh" borderLeft="1px solid lightgray" minWidth="200px" px={3}>
                <LabelWrapper label="Select Theme" />
                <Typography variant="body2" fontSize="12px" gutterBottom>Select from our prebuilt themes:</Typography>
                <CustomDropdown
                    options={formTemplates.map((item) => ({
                        label: item.template_name,
                        value: item.id
                    }))}
                    value={formFields.formTemplateId}
                    onChange={(e) => onChangeTemplate(e.target.value as string)}
                />
            </Box>
        </Box>
    </CardWrapper>);
};

export default PreviewFormComponent;